export class UploadStory {
    storybookLevel: string;
    storybookCategory: string;
    storyFileUpload: File;
    storyFileName: string;
    soundFileUpload?: File;
    hasAudio: boolean;
    soundFileName: string;
    storyName: string;
    coverImageFilePath?: string;
    // coverImageFileName
}